module.exports = __webpack_public_path__ + "static/img/server1.dc6eb8f8.png";